// Stub-only: importing the full runtime's i18n here would create a shared
// module chunk and break the classic-script embed. A test pins these twins.
const labels: Record<string, string> = {
  en: "Open chat", de: "Chat öffnen", sv: "Öppna chatten", fr: "Ouvrir le chat",
  it: "Apri chat", nb: "Åpne chat", fi: "Avaa chat", da: "Åbn chat",
  nl: "Chat openen", pl: "Otwórz czat", cs: "Otevřít chat", es: "Abrir chat", ja: "チャットを開く",
};

export function launcherLabel(locale?: string): string {
  const base = locale?.toLowerCase().split(/[-_]/)[0] || "en";
  return labels[base === "no" || base === "nn" ? "nb" : base] ?? labels.en;
}
